<template>
	<el-dialog title="选择功能区" :visible.sync="visible" width="680px" :before-close="befclose" :close-on-click-modal="false">
		<div>
			<el-checkbox-group v-model="checkedList" size="medium">
				<el-row :gutter="20">
					<el-checkbox v-for="(item,index) in provinceList" :label="item.id" :key="index" :value="item" :disabled="item.disabled" border size="medium">
					<el-popover
						v-if="item.name.split('').length > 9"
						placement="bottom"
						title=""
						width="150"
						trigger="hover"
						:content="item.name">
						<span slot="reference">{{item.name}}</span>
					</el-popover>
					<span v-else>{{item.name}}</span>
						
					</el-checkbox>
				</el-row>
			</el-checkbox-group>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button @click="handleCancel">取 消</el-button>
			<el-button type="primary" @click="handleConfirm">确 定</el-button>
		</span>
	</el-dialog>
</template>
<script>
import {crmApi}  from "@/services";
// const R = require("ramda")
// import moment from 'moment'
export default {
	props: {
		visible: {
			type: Boolean,
			required: true
		},
		provinceList: {
			type: Array,
			required: true
		},
		saveProjectFromBudget:{
			type: Array,
			default() {
				return []
			}
		},
	},
	data() {
		return {
			proviceList: [],
			checkedList: []
		};
	},
	watch:{
		saveProjectFromBudget:{
			handler: function(newValue, oldValue) {
				const checkedProvices = newValue.map((item) => {
					return item.functionalAreaCode
				})
				this.checkedList = checkedProvices;
			},
			immediate: true,
			deep: true
		},
		visible() {
			let flag = this.visible;
			let saveProjectFromBudget = this.saveProjectFromBudget;
			if (flag) {
				if (saveProjectFromBudget.length === 0) {
					this.checkedList.splice(0, this.checkedList.length);
				}
			}
		}
	},
	methods: {
		handleCancel() {
			this.$emit("handelCancel")
		},
		handleConfirm() {
			if(this.checkedList.length <=0){
				 this.$message.error('请选择功能区');
			}else{
				//过滤出选中的数据
				let zoneList = this.provinceList.filter((city) =>{
					return this.checkedList.includes(city.id)
				});
				//优先用传入的数据
				zoneList.forEach((item,index) => {
					for(let i =0 ;i<this.saveProjectFromBudget.length;i++){
						let zone = this.saveProjectFromBudget[i];
						if(item.id == zone.functionalAreaCode){
							zoneList[index] = {
								functionalAreaCode:item.id,
								functionalAreaName:item.name,
								functionalAreaStartDate:moment().format('x'),
								functionalAreaEndDate:parseInt(moment().format('x'))+24*3600*30*1000,
								budgetDetail:zone.budgetDetail,
								depreciateDevice:zone.depreciateDevice?zone.depreciateDevice:[],
								augmentDevice:zone.augmentDevice?zone.augmentDevice:[],
								deviceBudgetFlag:zone.deviceBudgetFlag,
								stageBudgetFlag:zone.stageBudgetFlag,
							};
							break;
						}else{
							zoneList[index] = {
								functionalAreaCode:item.id,
								functionalAreaName:item.name,
								functionalAreaStartDate:moment().format('x'),
								functionalAreaEndDate:parseInt(moment().format('x'))+24*3600*30*1000,
								budgetDetail:[],
								depreciateDevice:[],
								augmentDevice:[],
								deviceBudgetFlag:"1",
								stageBudgetFlag:"1",
								
							};
						}		
					}
				});
				console.log(zoneList);
				this.$emit("handelConfirm", zoneList);
			}
		},
		befclose(){
			this.$emit("handelCancel");
		},
	}
};
</script>
<style lang="scss" scoped>
.el-dialog__wrapper {
	/deep/.el-dialog__header{
		padding: 10px 40px 0px 40px;
		.el-dialog__title{
			line-height: 53px;
		}
	}
	/deep/.el-dialog__body {
		padding: 10px 20px;
		.el-checkbox-group{
			.el-col-6{
				margin-top: 10px;
				.grid-content{
					background-color: #f5f6fb ;
					height: 40px;
					color: #323232
				}
			}
			.el-checkbox{
				background-color: #f5f6fb ;
				height: 40px;
				color: #323232;
			    width: calc( 22% - 6px);
				text-align: center;
				margin: 0;
				margin-top: 15px;
				margin-left: 13px;
				margin-right: 12px;
				padding: 7px 10px 7px 10px;
				white-space:nowrap; 
    			overflow:hidden; 
				.el-checkbox__label{
					padding: 0;
				}
				.el-checkbox__inner{
					display: none;
				}
			}
			.is-checked{
				background-image: url(../../asserts/img/btn_xuanzhong.png);
				background-repeat: no-repeat;
				background-position: top right
			}
		}
		.el-col-6{
			margin-top: 10px;
			.grid-content{
				background-color: #f5f6fb ;
				height: 40px;
				color: #323232
			}
		}
	}
}
</style>
